import { createContext, useContext } from 'react';

import type { FormUser, FormQuestion } from '@amzn/coral_com-amazon-asxcustomerprofileservice';

export interface CreditsInterestFormContext {
  partialUser?: FormUser;
  partialQuestions?: FormQuestion[];
}

export const IntakeFormContext = createContext<CreditsInterestFormContext | null>(null);

export const useIntakeForm = () => {
  const context = useContext(IntakeFormContext);
  if (context === null) throw new Error('useIntakeForm must be used within IntakeFormPage');
  return context;
};
